import React from "react";
import {
  Avatar,
  Button,
  Box,
  Heading,
  Container,
  Center,
  Wrap,
  WrapItem,
  Text,
  HStack,
} from "@chakra-ui/react";
import { Link } from "gatsby";

const Species = (props) => {
  const { speciesRef, speciesOptions } = props;

  return (
    <Center>
      <Container
        maxW="7xl"
        borderWidth="1px"
        borderRadius="lg"
        p="10vh"
        ref={speciesRef}
      >
        <HStack>
          <Heading size="lg" color="gray">
            <Link to="/journals/biology/species">Species</Link>
          </Heading>
          <Text>Click to view the respective corpus</Text>
        </HStack>
        <Wrap>
          {speciesOptions.map((species) => (
            <WrapItem key={species.value}>
              <Link
                to={`/journals/biology/species/${species.value
                  .replace(".", "")
                  .replace(" ", "-")}`}
              >
                <Box as={Button} variant="outline" size="lg">
                  <Avatar
                    size="sm"
                    name={species.label}
                    src={
                      species.imageSrc &&
                      `/static/images/species-small/${species.imageSrc}`
                    }
                  />
                  <Text paddingLeft="1">{species.label}</Text>
                </Box>
              </Link>
            </WrapItem>
          ))}
        </Wrap>
      </Container>
    </Center>
  );
};

export default Species;
